namespace Matrix.Data {
    export interface DataColumn {
        Name?: string;
        Title?: string;
        Type?: DataType;
        Size?: number;
        Scale?: number;
        DisplayFormat?: string;
        Alignment?: string;
        Width?: number;
        FormatterType?: string;
        FormatterParams?: { [key: string]: any };
        Sortable?: boolean;
        SortOrder?: number;
        GroupOrder?: number;
        SummaryType?: Serenity.SummaryType;
        EditorType?: string;
        EditorParams?: { [key: string]: any };
        FilteringType?: string;
        FilteringParams?: { [key: string]: any };
        FilteringIdField?: string;
        FilterOnly?: boolean;
        NotFilterable?: boolean;
        QuickFilter?: boolean;
        QuickFilterParams?: { [key: string]: any };
        QuickFilterSeparator?: boolean;
        QuickFilterCssClass?: string;
        Visible?: boolean;
    }
}
